import { Box, Grid } from "@mui/material";
import { setLibraryRecentSearch, setSearchActive } from "components/app/App.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import Typography from "components/common/Typography";
import Plans from "components/common/plans/plans.layout";
import { fetchPlansAsync } from "components/common/plans/plans.slice";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE, allPlansType, missingIncodeText } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { pageNames } from "utils/Types";
import SuggestedPlans from "../SuggestedPlans";
import { fetchSuggestedPlansIdAsync } from "../SuggestedPlans/SuggestedPlans.slice";

function ActionPlans() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const searchText = searchParams.get("q") as string;
  const dispatch = useAppDispatch();
  const plansList: any = useAppSelector((state) => state.plans.list);
  const totalRecords: any = useAppSelector((state) => state.plans.totalRecords);
  const [pageNo, setPageNo] = useState(1);
  const localSearch = searchParams.get("search");
  const globalFiltersforPage = useAppSelector(
    (state) =>
      state.globalFilters[id ? filterPage.libraryFunctionalAreasDisplay : filterPage.libraryAllPlansSearchDisplay]
  );
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);

  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedFunctionalAreas = useAppSelector((state: any) => state.app.selectedFunctionalAreas);
  const suggestedPlanIds: any = useAppSelector((state) => state.suggestedPlans.listIds);
  const { isCorp, isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);
  const suggestedPlans: any = useAppSelector((state) => state.suggestedPlans.SuggestedPlansList);
  const showSuggested = !isCorp && !isAbovePropertyUser;
  const libraryRecentSearch = useAppSelector((state) => state.app.libraryRecentSearch);

  useEffect(() => {
    const props: any = getProps(1);
    if (searchText || localSearch) props.sort = { property: "relevance", direction: "ASC" };
    if (innCode !== missingIncodeText) {
      dispatch(fetchPlansAsync(props));
      setPageNo(1);
    }
    showSuggested && getSuggestedPlansIds();
  }, [dispatch, id, innCode, searchText, localSearch, filterRequestPayload]);

  const getProps = (page?: number) => {
    if (isEmpty(searchText || localSearch)) dispatch(setSearchActive(false));
    return {
      filter: {
        innCode,
        functionalAreaIds: id ? [id] : selectedFunctionalAreas,
        ...formattedFilterRequestPayload
      },
      pagination: {
        page: page ?? pageNo + 1,
        size: PAGE_SIZE
      },
      searchText: searchText || localSearch,
      planType:
        formattedFilterRequestPayload["planType"]?.length > 0
          ? formattedFilterRequestPayload["planType"]
          : [allPlansType],
      isSortingDisabled: true
    };
  };

  const getSuggestedProps = () => {
    return {
      functionalAreaIds: id ? [id] : selectedFunctionalAreas,
      searchText: searchText || localSearch,
      filtersRequest: { ...formFilterRequestPayload(filterRequestPayload) }
    };
  };

  const getSuggestedPlansIds = () => {
    dispatch(fetchSuggestedPlansIdAsync({ innCode }));
  };

  const fetchMore = () => {
    const props = getProps();
    dispatch(fetchPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  return (
    <Box margin="-16px 0 16px">
      <Grid container justifyContent="space-between"></Grid>
      <Grid item md={12}>
        <div
          style={{
            display: !id ? "flex" : undefined,
            justifyContent: !id ? "space-between" : undefined
          }}
        >
          {!id && <Box></Box>}
          <GlobalFilters
            isSearchBarVisible={id ? true : false}
            page={id ? filterPage.libraryFunctionalAreasDisplay : filterPage.libraryAllPlansSearchDisplay}
            functionalAreaId={id}
            applyFilterToMultiplePages={[filterPage.libraryAllPlansSearchIndividualActionsDisplay]}
            setRecentSearch={setLibraryRecentSearch}
            libraryRecentSearch={libraryRecentSearch}
          />
        </div>
        <GlobalFilterDescription
          page={id ? filterPage.libraryFunctionalAreasDisplay : filterPage.libraryAllPlansSearchDisplay}
          bgColor={tokens.Background.General.Primary}
        />
        {showSuggested && suggestedPlanIds?.length > 0 && (
          <div style={{ marginTop: "16px" }}>
            <SuggestedPlans filters={getSuggestedProps()} suggestedPlanIds={suggestedPlanIds} />
          </div>
        )}
        {suggestedPlans && suggestedPlans?.length > 0 && (
          <Typography
            variant={"h5"}
            color={tokens.Text.General.PrimaryHeadline}
            showBold
            sx={{ marginTop: "16px", marginBottom: "-8px" }}
          >
            All Plans
          </Typography>
        )}
        <Plans
          pageName={id ? pageNames.functionalArea : pageNames.searchResult}
          plansList={plansList}
          totalList={totalRecords}
          loadMore={fetchMore}
        ></Plans>
      </Grid>
    </Box>
  );
}

export default ActionPlans;
